var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"b-text-img"},[_c('div',{staticClass:"b-text-img__text t-t6"},[_vm._v(_vm._s(_vm.data.heading))]),_c('asset',{staticClass:"b-text-img__asset",attrs:{"asset":_vm.data.image}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }